/**
 * Generate initials from a user's first and last name
 */
export function generateInitials(firstName?: string | null, lastName?: string | null): string {
  if (!firstName && !lastName) {
    return '?';
  }
  
  const first = firstName?.trim().charAt(0).toUpperCase() || '';
  const last = lastName?.trim().charAt(0).toUpperCase() || '';
  
  if (first && last) {
    return `${first}${last}`;
  }
  
  return first || last || '?';
}

/**
 * Generate a full display name from first and last name
 */
export function generateDisplayName(firstName?: string | null, lastName?: string | null): string {
  const first = firstName?.trim() || '';
  const last = lastName?.trim() || '';
  
  if (first && last) {
    return `${first} ${last}`;
  }
  
  return first || last || 'Unknown User';
}

/**
 * Generate avatar URL for Supabase storage
 */
export function getAvatarUrl(avatarUrl?: string | null, companyId?: string): string | undefined {
  if (!avatarUrl || !companyId) {
    return undefined;
  }
  
  // If it's already a full URL, return as is
  if (avatarUrl.startsWith('http')) {
    return avatarUrl;
  }
  
  // Construct Supabase storage URL
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  return `${supabaseUrl}/storage/v1/object/public/avatars/${avatarUrl}`;
}
